import { BlobServiceClient } from '@azure/storage-blob';
import { Http } from '../Http';
import { getUserAccessToken } from '../selectors/Accounts';

const imageContainer = 'dab-images';
const audioContainer = 'dab-audios';
const videoContainer = 'dab-videos';

const createBlobInContainer = async (containerClient, file, fname) => {
  var fileName = fname + "_" + file.name;
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(fileName);

  // set mimetype as determined from browser with file upload control
  const options = {
    blobHTTPHeaders: {
      blobContentType: file.type,
      blobCacheControl: "public, max-age=31536000, immutable",
    },
  };

  // upload file
	await blobClient.uploadBrowserData(file, options);

	var blobClientUrl = blobClient.url.split("?")[0];

	//return fileName;
	return blobClientUrl;
};

const getTokenFromAPI = async (key: any) => {
  var input = { tokenType: "" };
  input.tokenType = key;
  // var obj = JSON.stringify(input);
  var url = '/api/Azure/sastoken';
	const resultMethod = Http.axios().post(url, input, { headers: { 'Authorization': getUserAccessToken() } })
    .then((res: any) => {
      return res;
    }).catch((e: any) => {
      return e.response;
	});

  return resultMethod;
}

const uploadFileToBlob = async (file, fname, filetype) => {
  if (!file) return "";
  var returnResult = "";

  try {
    const apiResult = await getTokenFromAPI(filetype);
    
    const blobService = new BlobServiceClient(apiResult.data.token);
    var contianer = "";
    if (filetype === "Audio") {
      contianer = audioContainer;
    } else if (filetype === "Video") {
      contianer = videoContainer;
    } else {
      contianer = imageContainer;
    }

    // get Container - full public read access
    const containerClient = blobService.getContainerClient(contianer);

    // upload file
    returnResult = await createBlobInContainer(containerClient, file, fname);

    return returnResult;
  } catch (e) {
    throw ("Error occured");
  }
};
export default uploadFileToBlob;
